/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button } from "@/components/ui/button";
import {
  Tooltip,
  TooltipArrow,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { LucideLoaderCircle, RotateCcw } from "lucide-react";
import { useReprocessErp } from "./hook/use-reprocess-erp";

export const ReprocessErp = ({
  data,
  company_id,
  user_id,
  globalLoading,
  setGlobalLoading,
  disabled,
}: any) => {
  const { process, reprocessCurrentErp } = useReprocessErp({
    company_id,
    user_id,
    globalLoading,
    setGlobalLoading,
  });
  return (
    <Tooltip>
      <TooltipTrigger asChild disabled={globalLoading || disabled}>
        <Button
          variant={"ghost"}
          size={"icon"}
          className="text-primary"
          disabled={globalLoading || disabled}
          onClick={() => reprocessCurrentErp(data)}
        >
          {process ? (
            <LucideLoaderCircle className="animate-spin" />
          ) : (
            <RotateCcw />
          )}
        </Button>
      </TooltipTrigger>

      <TooltipContent>
        <p>Reprocess Erp</p>
        <TooltipArrow />
      </TooltipContent>
    </Tooltip>
  );
};
